import Vue from 'vue'
import axios from 'axios';
import {
    Message
} from 'element-ui'
// import elUi from 'element-ui';
var baseUrl = window._CONFIG['domianURL']
var staticDomainURL = baseUrl.replace(/\/+$/, '') + '/sys/common/static/'
export function getFileAccessHttpUrl(url, base = staticDomainURL) {
    if (typeof url !== 'string' || !url) return ''
    url = url.trim()
    if (!url) return ''
    if (/^(https?:)?\/\/[^/]|^blob:/i.test(url)) return url
    if (/^data:image\/(png|jpe?g|gif|webp|bmp);base64,[a-z0-9+/]+={0,2}$/i.test(url)) return url
    if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return ''
    return base.replace(/\/+$/, '') + '/' + url.replace(/^\/+/, '')
}

// var service = axios.create({
//     timeout:5000
// })
axios.defaults.timeout = 9000
axios.defaults.headers['Access-Control-Allow-Origin'] = '*'; // 允许任何源的跨域请求
axios.defaults.headers['Accept'] = 'application/json';
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.get['content-type'] = 'application/json;charset=UTF-8';

axios.defaults.baseURL = baseUrl
axios.defaults.withCredentials = true;
axios.interceptors.request.use(config => {
    return config
}, err => {
    return Promise.reject(err)
})

axios.interceptors.response.use(res => {
    if (res.status != 200) {
        Message({
            message: res.message,
            type: 'error',
            duration: 5 * 1000

        })
    } else {
        return res.data
    }
}, err => {
    return Promise.reject(err)
})


export function get(url, params) {
    console.log('get', url, params)
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err)
        })
    });
}

export { baseUrl }






































// var httpgin = (Vue) => {
//     Vue.prototype.$http = axios
// };

// export default httpgin;

// export default (config = {}) => axios({
//     method: 'GET',
//     timeout: 120000,
//     withCredentials: true,
//     responseType: 'json',

//     ...config,

//     headers: {
//         "Content-Type": "application/json",
//     },
//     baseURL: "http://192.168.0.112:9000",



//     transformResponse: [
//         res => {
//             if ("ActiveXObject" in window && typeof res === 'string' && (config.responseType === 'json' || !config.responseType)) res = JSON.parse(res);

//             // 统一处理接口调用不成功后的提示
//             if ((!res || res.code * 1 != 200) && !config.noMsg && (config.responseType === 'json' || !config.responseType)) elUi.Message.error(res && res.message || '请求已取消');


//             return res || {};
//         }
//     ],


// }).then(res => res.data).catch(err => {
//     if (!config.noMsg) elUi.Message.error(`出现错误：${err}, 请刷新重试`)
//     return config.responseType === 'json' || !config.responseType ? {  code: 0 } : false;
// })
